// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/transportation/crew/crew.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyRequest, EmptyResponse } from "../../../common/messages/messages";
import {
  AddCrewSsoUsernameRequest,
  AddCrewSsoUsernameResponse,
  AddNewCrewChangeRequest,
  AddNewCrewChangeResponse,
  AssignedVesselImoResponse,
  Crew,
  CrewResponse,
  GetCrewByIdRequest,
  GetCrewResponse,
  GetCrewsByVesselImoRequest,
  GetOnboardCrewByVesselImoRequest,
  GetOnboardCrewResponse,
  SubmitAppraisalRequest,
  UpdateCrewChangeContractRequest,
  UpdateCrewChangeContractResponse,
  UpdateCrewChangePlanRequest,
  UpdateCrewChangePlanResponse,
  UpdateCrewRequest,
} from "./crew";

import { CrewServiceClientImpl } from "./crew";

@Injectable({ providedIn: "root" })
export class CrewServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async addCrew(request: Crew): Promise<CrewResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.addCrew(request);
  }
  async updateCrew(request: UpdateCrewRequest): Promise<CrewResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.updateCrew(request);
  }
  async updateAppraisal(request: SubmitAppraisalRequest): Promise<EmptyResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.updateAppraisal(request);
  }
  async addCrewSsoUsername(request: AddCrewSsoUsernameRequest): Promise<AddCrewSsoUsernameResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.addCrewSsoUsername(request);
  }
  async addNewCrewChange(request: AddNewCrewChangeRequest): Promise<AddNewCrewChangeResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.addNewCrewChange(request);
  }
  async updateCrewChangePlan(request: UpdateCrewChangePlanRequest): Promise<UpdateCrewChangePlanResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.updateCrewChangePlan(request);
  }
  async updateCrewChangeContract(request: UpdateCrewChangeContractRequest): Promise<UpdateCrewChangeContractResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.updateCrewChangeContract(request);
  }
  async getCrew(request: EmptyRequest): Promise<GetCrewResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.getCrew(request);
  }
  async getCrewWithOnboardCrewChange(request: EmptyRequest): Promise<GetOnboardCrewResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.getCrewWithOnboardCrewChange(request);
  }
  async getCrewWithOnboardCrewChangeByVesselImo(
    request: GetOnboardCrewByVesselImoRequest,
  ): Promise<GetOnboardCrewResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.getCrewWithOnboardCrewChangeByVesselImo(request);
  }
  async getAssignedVesselImoForCrew(request: EmptyRequest): Promise<AssignedVesselImoResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.getAssignedVesselImoForCrew(request);
  }
  async getCrewById(request: GetCrewByIdRequest): Promise<CrewResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.getCrewById(request);
  }
  async getCrewByName(request: Crew): Promise<CrewResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.getCrewByName(request);
  }
  async getCrewsByVesselImo(request: GetCrewsByVesselImoRequest): Promise<GetCrewResponse> {
    const client = new CrewServiceClientImpl(this._rpc);
    return await client.getCrewsByVesselImo(request);
  }
}
